import * as cx from 'classnames'
import * as React from 'react'

import { IItemCard } from '../interface'

import LockupAddToCartButton from '../lockupAddToCartButton'
import LockupLastUpdated from '../lockupLastUpdated'
import LockupPrice from '../lockupPrice'
import LockupRating from '../lockupRating'
import LockupSales from '../lockupSales'
import LockupTitleAuthor from '../lockupTitleAuthor'
import * as styles from './itemCardContentCommonWrapper.module.css'

interface IProps extends IItemCard {
  children: React.ReactNode
}

interface IState {
  showingMore: boolean
}

class ItemCardContentCommonWrapper extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = { showingMore: false }
    this.toggleShowMore = this.toggleShowMore.bind(this)
  }

  public render() {
    const { showingMore } = this.state
    const { children, viewType } = this.props
    const showMoreLabel = showingMore ? 'Show less' : 'Show more'
    const rootClass = viewType === 'list' ? styles.listView : styles.gridView
    return (
      <div className={rootClass}>
        <div className={styles.titleAuthor}>
          <LockupTitleAuthor {...this.props} />
        </div>
        <div className={styles.gridAndMobileItemMeta}>
          <div className={styles.price}>
            <LockupPrice priceInCents={this.props.item.price_cents} />
          </div>
          <div className={styles.rating}>
            <LockupRating {...this.props} />
          </div>
          <div className={styles.sales}>
            <LockupSales {...this.props} />
          </div>
          <div
            className={styles.showMoreHitArea}
            role="button"
            aria-label={showMoreLabel}
            onClick={this.toggleShowMore}
          >
            <div className={styles.showMoreLabel}>{showMoreLabel}</div>
          </div>
          <div className={styles.addToCartButton}>
            <LockupAddToCartButton icon {...this.props} />
          </div>
        </div>
        <div
          className={cx(styles.itemContent, {
            [styles.moreInfoVisible]: showingMore
          })}
        >
          <div className={styles.moreInfoSalesAndUpdated}>
            <LockupSales {...this.props} />
            <LockupLastUpdated {...this.props} />
          </div>
          {children}
        </div>
      </div>
    )
  }

  private toggleShowMore() {
    this.setState({ showingMore: !this.state.showingMore })
  }
}

export default ItemCardContentCommonWrapper
